import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import HighlightOff from '@material-ui/icons/HighlightOff';
import { observer } from 'mobx-react';

import { translate } from 'services/i18nService';
import CampaignNotification from 'components/ChatNotificationsTypes/CampaignNotification';
import Button from 'components/Button/Button';
import ThemeService from 'themes/ThemeService';

import TokenAwarenes from './TokenAwareness';
import styles from './TokenAwarenessDesktop.css';


function TokenAwarenessDesktop(props) {
  const { closeOverlay, showBuyTokensModal } = props;
  const { theme } = ThemeService;

  const buttonElement = useMemo(() => {
    if (theme?.mobileOverlay) {
      return <CampaignNotification showBuyTokensModal={showBuyTokensModal} />;
    }

    return (
      <Button
        colour="green"
        id="buyNowTokensOverlayId"
        label={translate('strings.tokenAawareness.overlay.buyTokensNow')}
        onClick={showBuyTokensModal}
      />
    );
  }, [showBuyTokensModal, theme?.mobileOverlay]);

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <TokenAwarenes />
        {buttonElement}
      </div>
      <div className={styles.footer}>
        <span id="closeTokeOverlayButtonId" onClick={closeOverlay}>
          <HighlightOff /> {translate('strings.tokenAawareness.overlay.remindMeLater')}
        </span>
      </div>
    </div>
  );
}

TokenAwarenessDesktop.propTypes = {
  closeOverlay: PropTypes.func.isRequired,
  showBuyTokensModal: PropTypes.func.isRequired,
};

export default observer(TokenAwarenessDesktop);
